<template>
	<div>
		<a-page-header style="background: #fff;" title="积分商城订单管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'积分商城订单管理'}]}}">
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input-group compact>
						<a-select style="width: 120px" v-model="searchForm.type">
							<a-select-option :value="1">订单号</a-select-option>
							<a-select-option :value="2">姓名</a-select-option>
							<a-select-option :value="3">电话</a-select-option>
							<a-select-option :value="4">昵称</a-select-option>
							<a-select-option :value="5">商品名称</a-select-option>
						</a-select>
						<a-input style="width: 300px" placeholder="请输入内容" v-model="searchForm.word" />
					</a-input-group>
				</a-form-model-item>
				<a-form-model-item>
					<a-select allowClear style="width: 150px" v-model="searchForm.storeId" placeholder="所属门店" :options="storeList"></a-select>
				</a-form-model-item>
				<a-form-model-item>
					<a-range-picker :locale="locale" format="YYYY-MM-DD" @change="dateChange" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
			<template slot="footer">
				<a-tabs @change="tabChange" v-model="status">
					<a-tab-pane key="0" tab="全部订单">
					</a-tab-pane>
					<a-tab-pane key="1">
						<span slot="tab">
							预约订单 <span style="color:#ff4d4f ;font-weight: 700;" v-if="orderNum.yyz">{{orderNum.yyz}}</span>
						</span>
					</a-tab-pane>
					<a-tab-pane key="2">
						<span slot="tab">
							待核销订单 <span style="color:#ff4d4f ;font-weight: 700;" v-if="orderNum.dhx">{{orderNum.dhx}}</span>
						</span>
					</a-tab-pane>
					<a-tab-pane key="3" tab="已完成订单">
					</a-tab-pane>
				</a-tabs>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="integralOrderNum" slot-scope="integralOrderNum">
						 {{integralOrderNum}}
					</span>
					<span slot="userInfo" slot-scope="text,userInfo">
						<a-tag color="orange" v-if="userInfo.userInfo.memberSfName">{{userInfo.userInfo.memberSfName}}</a-tag>
						<div>
							<a-icon type="user" /> {{userInfo.userInfo.memberName}}
						</div>
						<div>
							<a-icon type="mobile" /> {{userInfo.userInfo.memberPhone}}
						</div>
						<div style="margin-top: 10px;">
							<a-avatar :src="userInfo.wxInfo.headpic" size="small" />
							{{userInfo.wxInfo.nickname}}
						</div>
					</span>
					<span slot="orderPay" slot-scope="text,orderPay">
						<div style="font-size: 24px;font-weight: 700;">{{orderPay.integralOrderJfUsed}} 积分</div>
					</span>
					<span slot="goodsInfo" slot-scope="text,goodsInfo">
						<div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
							<div style="padding-right: 10px;">
								<a-avatar shape="square" :size="50" :src="goodsInfo.goodsInfo.integralGoodsThumb" />
							</div>
							<div style="width: 80%;display: flex;align-content: space-between;flex-direction:column">
								<div style="font-weight: 700;margin-bottom: 5px;">
									{{goodsInfo.goodsInfo.integralGoodsName}}
								</div>
								<div> <span style="font-weight: 700;">{{goodsInfo.goodsInfo.integralGoodsPrice }} 积分</span>
								</div>
							</div>
						</div>
					</span>
					<span slot="orderStatus" slot-scope="text,orderStatus">
						<template v-if="orderStatus.integralOrderStatus == 1">
							<a-tag color="orange">
								<a-icon type="history" /> 预约</a-tag>
							<div>
								<a-icon type="calendar" /> {{orderStatus.appointmentDate}}</div>
						</template>
						<a-tag color="blue" v-if="orderStatus.integralOrderStatus == 2">
							<a-icon type="qrcode" /> 待核销</a-tag>
						<a-tag color="green" v-if="orderStatus.integralOrderStatus == 3">
							<a-icon type="check-circle" /> 已完成</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
					</span>
				</a-table>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '订单号',
			dataIndex: 'integralOrderNum',
			scopedSlots: {
				customRender: 'integralOrderNum'
			},
		},
		{
			title: '下单人',
			dataIndex: 'userInfo',
			scopedSlots: {
				customRender: 'userInfo'
			},
		},
		{
			title: '商品信息',
			dataIndex: 'goodsInfo',
			scopedSlots: {
				customRender: 'goodsInfo'
			},
		},
		{
			title: '支付信息',
			dataIndex: 'orderPay',
			scopedSlots: {
				customRender: 'orderPay'
			},
		},
		{
			title: '下单时间',
			dataIndex: 'addTime',
		},
		{
			title: '订单状态',
			dataIndex: 'orderStatus',
			scopedSlots: {
				customRender: 'orderStatus'
			},
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				moment,
				locale,
				columns,
				list: [],
				storeList: [],
				fileList: [],
				info: '',
				labelCol: {
					span: 5
				},
				wrapperCol: {
					span: 14
				},
				searchForm: {
					type:1
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {},
				addModal: false,
				loading: false,
				addRules: {
					housetypeName: [{
						required: true,
						message: '请填写户型名称',
						trigger: 'blur'
					}],
					housetypeInArea: [{
						required: true,
						message: '请填写套内面积',
						trigger: 'blur'
					}],
					housetypeBuildArea: [{
						required: true,
						message: '请填写建筑面积',
						trigger: 'blur'
					}],
					housetypeOrientation: [{
						required: true,
						message: '请选择朝向',
						trigger: 'blur'
					}],
					housetypeHouse: [{
						required: true,
						message: '请选择所属楼盘',
						trigger: 'change'
					}],
				},
				previewVisible: false,
				previewImage: '',
				status: '0',
				orderNum: ''
			};
		},

		mounted() {
			this.getList()
			this.getStoreList()
			this.getCount()
		},

		methods: {
			tabChange() {
				this.getList()
				this.getCount()
			},
			
			dateChange(value, dateString){
				console.log(value, dateString)
				this.searchForm.dateBegin = dateString[0]
				this.searchForm.dateEnd = dateString[1]
			},
			
			toDetail(id) {
				this.$router.push('/integral/integralOrderDetail?id=' + id)
			},


			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					status: this.status,
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					type: this.searchForm.type,
					word: this.searchForm.word,
					storeId: this.searchForm.storeId,
					startTime: this.searchForm.dateBegin,
					endTime: this.searchForm.dateEnd,
				}
				this.$http.post('/admin/index.php/admin/Shop/integralOrderList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			
			getStoreList() {
				this.$http.get('/admin/index.php/admin/Shop/storePullList').then(res => {
					if (res.data.code == 1) {
						this.storeList = res.data.data
					}
				})
			},
			
			getCount() {
				this.$http.get('/admin/index.php/admin/Shop/integralStatusCount').then((res) => {
					if (res.data.code == 1) {
						this.orderNum = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
